<template>
  <div class="seltree">
    <el-select v-model="valueTitle"
               :style="{'width':width}"
               :disabled="disabled"
               :clearable="clearable"
               filterable
               :filter-method="searchTreeNode"
               @clear="clearHandle"
               @focus="selFocus">
      <el-option :style="{'width':width}" class="tree-option" :value="valueTitle" :label="valueTitle">
          <div class="selTreeBox">
            <el-tree
                class="sel-tree"
                ref="eltree"
                :props="defaultProps"
                :data="treeData"
                node-key="id"
                highlight-current
                :check-strictly="strictly"
                :expand-on-click-node="false"
                :default-expanded-keys="defExpandNode"
                :default-checked-keys="defCheckedNode"
                :show-checkbox="showCheckbox"
                @node-click="handleNodeClick"
                @check-change="handleCheckChange"
                @check="hanleCheck"
                :filter-node-method="filterNode">
            </el-tree>
          </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import {IsNull} from "@/config/validate/common"

export default {
  name: "selectTree",
  props: {
    sourceData: { // 源数据
      type: Array,
      required: true,
    },
    formatTreeData: {
      required: true,
      default: () => (
          {
            id: "", // 映射节点id 必传
            label: "", // 映射节点名称 必传
            pcode: "", // 映射节点关系中的父节点code 必传
            code: '', // 映射节点code 必传
            nodetype: '', // 映射节点类型
            disabled: 'disabled', // 映射能否checkd
            extra: [] // 节点添加的额外属性
          }
      )
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    }, // 是否显示checkbox
    strictly: {
      type: Boolean,
      default: true
    }, // check的父子互不关联
    width: {
      type: String,
      default: '200px'
    },
    nodeId: { // 回显节点id
      // type:Number,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: { // 默认删除按钮不显示
      type: Boolean,
      default: false
    }
  },
  watch: {
    nodeId(val) {
      this.initHandle()
    },
    sourceData(val) {
      this.integratedData(val, this.formatTreeData)
    }
  },
  data() {
    return {
      filterText: '',
      valueTitle: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      treeData: [],
      midData:new Map(), // 整合数据时需要借助的中间数据
      //hacksel: false, // 加这个字段是为了下拉框要与select输入框宽度一致
      defExpandNode: [],
      defCheckedNode: []
    }
  },
  methods: {
    setLabel(txt) {
      this.valueTitle = txt;
    },
    selFocus(val){
        this.$refs.eltree.filter('');
    },
    // 初始化值
    initHandle() {
      if (!!this.nodeId) {
        this.$nextTick(() => {
          if (!!this.$refs.eltree) {
            if(!this.$refs.eltree.getNode(this.nodeId)) return
            let node = this.$refs.eltree.getNode(this.nodeId)
            this.valueTitle = node.label // 初始化显示
            this.$refs.eltree.setCurrentKey(this.nodeId)       // 设置默认选中
            this.defExpandNode = [this.nodeId]      // 设置默认展开
            this.$emit('getNode', node)
          }
        })
      }else{
          this.valueTitle = '';
      }
    },
    clearHandle() {
      this.defExpandNode = []
      this.collapseAll()
      this.$emit('clearMethod')
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    searchTreeNode(val) {
        val = val.replace(/(^\s+)|(\s+$)/g, "")
        if(val.length>1){
            this.$refs.eltree.filter(val);
        }else{
            this.$refs.eltree.filter('');
        }
    },
    // 以下都为tree的方法
    handleNodeClick(data,node,self) {
      this.$emit('getValueMethod', data)
    },
    handleCheckChange(node, checked, indeterminate) { // 选中时的节点回调
      this.$emit('checkTreeNode', node, checked, indeterminate)
    },
    hanleCheck(node, checked) {
      this.$emit('checkNodeClick', node, checked)
    },
    collapseAll() { // 全部折叠
      this.sourceData.forEach(data => {
        this.$refs.eltree.store.nodesMap[data[this.formatTreeData.id]].expanded = false
      });
    },
    getTreeNode(key){
        let node = this.$refs.eltree.getNode(key);
        return node;
    },
    getParentLable(key) {
      let node = this.$refs.eltree.getNode(key)
      if (node.parent.label === undefined) {
        return "无"
      }
      return node.parent.data.label
    },
    getParentKey(key) {
      let node = this.$refs.eltree.getNode(key)
      if (node.parent.label === undefined) {
        //    console.log('已经是根节点了')
        return
      }
      return node.parent.data.id
    },
    // 下面开始整合数据
    integratedData(sourcelist,tjson){
        this.formatTreeData.iconCust = ['delIcon','editIcon','addIcon'];
        //开始查找根节点
        let pCodeMap = new Map();
        let pCode;
        sourcelist.forEach(item => {
            pCode = item[tjson['pcode']];
            if(!pCodeMap.has(pCode)){
                pCodeMap.set(pCode,false);
            }
        });
        let code;
        sourcelist.forEach(item => {
            code = item[tjson['code']];
            if(pCodeMap.has(code)){
                pCodeMap.set(code,true);
            }
        });
        let newData = [];
        sourcelist.forEach(item => {
            pCode = item[tjson['pcode']];
            if(pCodeMap.get(pCode)){
                if(this.midData.has(pCode)){
                    this.midData.get(pCode).push(item);
                }else{
                    this.midData.set(pCode,[item]);
                }
            }else{
                let jsonData = this.complieSource(item,tjson);
                newData.push(jsonData);
            }
        });
        //递归整理数据
        this.treeData = this.recursiveData(newData,tjson);
        this.initHandle();
    },
    //递归整理数据
    recursiveData(treeData,tjson){
        treeData.forEach(ele => {
            let child = [];
            let code = ele.code;
            if(this.midData.has(code)){
                this.midData.get(code).forEach(item => {
                    let jsonData = this.complieSource(item,tjson);
                    child.push(jsonData);
                });
                this.midData.delete(code);
                ele.children = child;
                this.recursiveData(ele.children,tjson);
            }
        });
        return treeData
    },
    complieSource(sourceitem, tjson) {
      let jsonData = {}
      for (let key in tjson) {
        if (key === 'nodetype') {
          if (!IsNull(tjson[key])) {
            jsonData[key] = sourceitem[tjson[key]]
            switch (jsonData[key]) { // 根据节点类型赋值icon
              case 1000:
                jsonData['icon'] = 'icon-pin';
                break;
              case 10011:
                jsonData['icon'] = 'icon-user';
                break;
              case 10012:
                jsonData['icon'] = 'icon-message';
                break;
              case 10013:
                jsonData['icon'] = 'icon-bell';
                break;
            }
          }
        } else if (key === "extra") {
          if (tjson.extra.length > 0) {
            jsonData.extra = {};
            tjson.extra.forEach(ele => {
              jsonData.extra[ele] = sourceitem[ele]
            });
          }

        } else if (key === "iconCust") {
          if (tjson.iconCust.length > 0) {
            jsonData.iconCust = {};
            tjson.iconCust.forEach(ele => {
              jsonData.iconCust[ele] = sourceitem[ele]
            });
          }
        } else {
          if (!IsNull(tjson[key])) {
            jsonData[key] = sourceitem[tjson[key]]
          }
        }
      }
      return jsonData
    },

  },
  mounted() {
      setTimeout(() => { // 异步渲染避免阻塞
          this.integratedData(this.sourceData, this.formatTreeData)
      },0);
  },
  activated(){
    this.initHandle()
  }
}
</script>

<style lang="less" scoped>
.theme2 .el-select-dropdown .el-scrollbar .el-select-dropdown__item.tree-option{background: #353638;}
.el-select-dropdown {
  .el-scrollbar {
    .el-select-dropdown__item.tree-option {
      height: 200px !important;
      padding: 0px;
      background: #fff;
    }
    .el-select-dropdown__item{
        font-weight: normal;
    }
    .selTreeBox{
        width: 100%;
        height: 100%;
        overflow: auto;
        &::-webkit-scrollbar {
            width: 4px;
            height: 10px;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(24, 25, 27, 0.2);
            background: rgba(24, 25, 27, 0.2);
        }

        &::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(24, 25, 27, 0.1);
            background: rgba(24, 25, 27, 0.1);
            border-radius: 0;
        }
        .el-tree {
            min-width: 100%;
            display: inline-block;
            margin-top: 10px;
            .el-tree-node {
                overflow: auto;
            }
        }
    }
  }
}
/deep/.selTreeBox .el-tree-node__label{
    padding-right: 10px;
}
</style>